module.exports = __webpack_public_path__ + "static/media/curoflow_telemedicine_platform_logo.9c4cc3c4.png";